// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/generations/v1/optimize_generation_prompt.proto (package protos.vision.generations.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/generations/v1/optimize_generation_prompt.proto.
 */
export const file_vision_generations_v1_optimize_generation_prompt: GenFile = /*@__PURE__*/
  fileDesc("CjZ2aXNpb24vZ2VuZXJhdGlvbnMvdjEvb3B0aW1pemVfZ2VuZXJhdGlvbl9wcm9tcHQucHJvdG8SHHByb3Rvcy52aXNpb24uZ2VuZXJhdGlvbnMudjEiyAEKH09wdGltaXplR2VuZXJhdGlvblByb21wdFJlcXVlc3QSVAoGcGFyYW1zGAEgASgLMkQucHJvdG9zLnZpc2lvbi5nZW5lcmF0aW9ucy52MS5PcHRpbWl6ZUdlbmVyYXRpb25Qcm9tcHRSZXF1ZXN0LlBhcmFtcxpPCgZQYXJhbXMSDgoGcHJvbXB0GAEgASgJEhcKDWdlbmVyYXRpb25faWQYAiABKAlIABISCghpbWFnZV9pZBgDIAEoCUgAQggKBnNvdXJjZSKdAQogT3B0aW1pemVHZW5lcmF0aW9uUHJvbXB0UmVzcG9uc2USVQoGcmVzdWx0GAEgASgLMkUucHJvdG9zLnZpc2lvbi5nZW5lcmF0aW9ucy52MS5PcHRpbWl6ZUdlbmVyYXRpb25Qcm9tcHRSZXNwb25zZS5SZXN1bHQaIgoGUmVzdWx0EhgKEG9wdGltaXplZF9wcm9tcHQYASABKAliBnByb3RvMw");

/**
 * @generated from message protos.vision.generations.v1.OptimizeGenerationPromptRequest
 */
export type OptimizeGenerationPromptRequest = Message<"protos.vision.generations.v1.OptimizeGenerationPromptRequest"> & {
  /**
   * @generated from field: protos.vision.generations.v1.OptimizeGenerationPromptRequest.Params params = 1;
   */
  params?: OptimizeGenerationPromptRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.OptimizeGenerationPromptRequest.
 * Use `create(OptimizeGenerationPromptRequestSchema)` to create a new message.
 */
export const OptimizeGenerationPromptRequestSchema: GenMessage<OptimizeGenerationPromptRequest> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_optimize_generation_prompt, 0);

/**
 * @generated from message protos.vision.generations.v1.OptimizeGenerationPromptRequest.Params
 */
export type OptimizeGenerationPromptRequest_Params = Message<"protos.vision.generations.v1.OptimizeGenerationPromptRequest.Params"> & {
  /**
   * @generated from field: string prompt = 1;
   */
  prompt: string;

  /**
   * @generated from oneof protos.vision.generations.v1.OptimizeGenerationPromptRequest.Params.source
   */
  source: {
    /**
     * @generated from field: string generation_id = 2;
     */
    value: string;
    case: "generationId";
  } | {
    /**
     * @generated from field: string image_id = 3;
     */
    value: string;
    case: "imageId";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message protos.vision.generations.v1.OptimizeGenerationPromptRequest.Params.
 * Use `create(OptimizeGenerationPromptRequest_ParamsSchema)` to create a new message.
 */
export const OptimizeGenerationPromptRequest_ParamsSchema: GenMessage<OptimizeGenerationPromptRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_optimize_generation_prompt, 0, 0);

/**
 * @generated from message protos.vision.generations.v1.OptimizeGenerationPromptResponse
 */
export type OptimizeGenerationPromptResponse = Message<"protos.vision.generations.v1.OptimizeGenerationPromptResponse"> & {
  /**
   * @generated from field: protos.vision.generations.v1.OptimizeGenerationPromptResponse.Result result = 1;
   */
  result?: OptimizeGenerationPromptResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.OptimizeGenerationPromptResponse.
 * Use `create(OptimizeGenerationPromptResponseSchema)` to create a new message.
 */
export const OptimizeGenerationPromptResponseSchema: GenMessage<OptimizeGenerationPromptResponse> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_optimize_generation_prompt, 1);

/**
 * @generated from message protos.vision.generations.v1.OptimizeGenerationPromptResponse.Result
 */
export type OptimizeGenerationPromptResponse_Result = Message<"protos.vision.generations.v1.OptimizeGenerationPromptResponse.Result"> & {
  /**
   * @generated from field: string optimized_prompt = 1;
   */
  optimizedPrompt: string;
};

/**
 * Describes the message protos.vision.generations.v1.OptimizeGenerationPromptResponse.Result.
 * Use `create(OptimizeGenerationPromptResponse_ResultSchema)` to create a new message.
 */
export const OptimizeGenerationPromptResponse_ResultSchema: GenMessage<OptimizeGenerationPromptResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_optimize_generation_prompt, 1, 0);

